const FIELD_CONFIGS = {
  name: [
    { field: 'firstName', type: 'text', label: 'First Name', placeholder: 'First Name' },
    { field: 'lastName', type: 'text', label: 'Last Name', placeholder: 'Last Name' }
  ],
  membership_status: [
    { 
      field: 'membershipStatus', 
      type: 'select', 
      label: 'Membership Status',
      options: [
        { value: 'active', label: 'Current member' },
        { value: 'inactive', label: 'Ex-member' },
        { value: 'supporter', label: 'Supporter (non-member)' }
      ]
    }
  ],
  join_date: [
    { field: 'joinDate', type: 'date', label: 'Joined Date' }
  ],
  date_of_birth: [
    { field: 'dateOfBirth', type: 'date', label: 'Date of Birth' }
  ],
  email: [
    { field: 'email', type: 'email', label: 'Email', placeholder: 'email@example.com', validation: 'email' }
  ],
  phone_numbers: [
    { field: 'phoneNumber', type: 'text', label: 'Phone Number', placeholder: '+44 123 456 7890', validation: 'phone' }
  ],
  address: [
    { field: 'addressLine1', type: 'text', label: 'Address', placeholder: '123 Main Street' },
    { field: 'addressLine2', type: 'text', label: '', placeholder: '' },
    { field: 'addressLine3', type: 'text', label: '', placeholder: '' },
    { field: 'addressLine4', type: 'text', label: '', placeholder: '' },
    { field: 'city', type: 'text', label: 'City', placeholder: 'London' },
    { field: 'postcodeData', type: 'postcode', label: 'Postcode & Country', validation: 'postcode' }
  ]
}

export { FIELD_CONFIGS }
